import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import Select from 'react-select';

class AirspaceResponsibleUnityLocationsAdd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: this.props.updated,
      active_tpo: 0,
      id: this.props.id,
      data: [],
    };
    //Handlers
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.updated !== "undefined") {
      this.setState({updated: newProps.updated});
    }
    if(typeof newProps.id !== "undefined" && (this.state.loaded === 0)) {
      this.setState({id: newProps.id});
    }
    if(Array.isArray(newProps.data) && Array.isArray(newProps.locations_select) && (this.state.loaded === 0 || this.state.updated === 1)) {
      this.setState({locations_select: newProps.locations_select, data: newProps.data, loaded:1, updated:0});
      newProps.refreshUpdated();
    }
    if(Array.isArray(newProps.airspace_responsible_unities_select)) {
      this.setState({airspace_responsible_unities_select: newProps.airspace_responsible_unities_select});
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      airspace_responsible_unity_id: this.state.airspace_responsible_unity_id,
      location_id: this.state.location_id,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controlador/unidade/localidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ data: responseJson.data });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var data_info_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/controlador/unidade/localidade/' + data_info_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <h3>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.titulo}</h3>
  <hr />
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.formulario.Localidade}:</label>
          <Select
            className="form-field-name"
            name="location_id"
            value={this.state.location_id}
            searchable={true}
            placeholder={this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.formulario.placeHolder.SelecionarLocalidade}
            onChange={this.handleSelectChange.bind(this, 'location_id')}
            options={this.state.locations_select}
            required
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.formulario.Unidade}:</label>
          <Select
            className="form-field-name"
            name="airspace_responsible_unity_id"
            value={this.state.airspace_responsible_unity_id}
            searchable={true}
            placeholder={this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.formulario.placeHolder.SelecionarUnidade}
            onChange={this.handleSelectChange.bind(this, 'airspace_responsible_unity_id')}
            options={this.state.airspace_responsible_unities_select}
            required
          />
        </div>
      </div>
    </div>
    <div>
      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.formulario.botaoAdicionarLocalidadeDaUnidade}</button>
    </div>
  </form>
  <hr />
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.tabela.Localidade}</th>
          <th>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.tabela.Unidade}</th>
          <th>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.localidadeDaUnidade.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="dates">
      {Object.keys(self.state.data).map(function(k) {
        var data_info = self.state.data[k];
        return (
          <tr>
            <td>{data_info.location.name}</td>
            <td>{data_info.airspace_responsible_unity.name}</td>
            <td>
              <button className="btn btn-sm btn-danger" value={data_info.id} onClick={self.delete}>
                <i className="fa fa-fw fa-trash"></i>
              </button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default AirspaceResponsibleUnityLocationsAdd;



// WEBPACK FOOTER //
// ./src/Components/AirspaceResponsibles/Elements/AirspaceResponsibleUnityLocationsAdd.js